import React, { useEffect, useState } from "react";
import { Table, Space, Spin, Modal, Button, Pagination, Badge, Tooltip } from "antd";
import detailsIcon from "../../assets/images/details-icon.svg";
// import previewIcon from "../../assets/images/preview-icon.svg";
// import unPublish from "../../assets/images/unpublish.svg";
import nologo from "../../assets/images/noimage.png";
import userServiceApi from "../../../src/api/userServiceApi";
import { getRequest, patchRequest, deleteRequest, postRequest } from "../../api/http";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import "./table.scss";
import ViewMicrosite from "./viewMicrosite";
import {
  MailOutlined,
  SortAscendingOutlined,
  SortDescendingOutlined,
} from "@ant-design/icons";
import ViewMicrositeDetails from "./viewMicrositeDetails";
import reviewicon from "../../assets/images/reviewicon.svg";
import deleteIcon from "../../assets/images/deleteIcon.svg";

const OrganizationTable = ({
  pagNumber,
  totalOrgs,
  activeKey,
  reloadFunction,
  data,
  filterExists,
  showSearchBarHandler,
  showTagsHandler,
  sortFunction,
  reviewPendingFunction,
  sortByFunction,
  ReviewHandler,
  handleBackClick,
  setreviewid,
  reviewCount,
}) => {
  const navigate = useNavigate();
  const [tableData, setTableData] = useState([]);
  const [isShowPreview, setIsShowPreview] = useState(false);
  // const [microSiteLoading, setLoading] = useState(false);
  const [microSitePublishLoading, setPublishLoading] = useState(false);
  // const [microSiteUpdateLoading, setUpdateLoading] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isModalDeleteOpen, setIsModalDeleteOpen] = useState(false);
  const [rowId, setRowId] = useState();
  const [deleteRowId, setDeleteRowId] = useState();
  const [loader, setLoader] = useState(true);
  const [orgId, setOrgId] = useState(null);
  // const [microsite, setMicrositeId] = useState(null);
  // const [micrositeData, setMicrositeData] = useState(null);
  const [micrositeModal, setMicrositeModal] = useState(false);
  const [micrositeModalDeatils, setMicrositeModalDetails] = useState(false);
  // const [pagination, setPagination] = useState({ current: 1, pageSize: 10 });
  const [pageSize, setPageSize] = useState(10);
  const [top, setTop] = useState("none");
  const [bottom, setBottom] = useState("none");
  const [isDisabled, setIsDisabled] = useState(true);
  // const [reviewPending, setReviewPending] = useState(false);

  const [sortDirection, setSortDirection] = useState("DESC");
  // const [sortBy, setSortBy] = useState();

  const [sectorName, setSectorName] = useState("");
  const [subSectorName, setSubSectorName] = useState("");
  const [sectorId, setSectorId] = useState(
    sessionStorage.getItem("sector") ? sessionStorage.getItem("sector") : null
  );
  const [subsectorId, setSubsectorId] = useState(
    sessionStorage.getItem("subsector") ? sessionStorage.getItem("subsector") : null
  );
  const [size, setSize] = useState(
    sessionStorage.getItem("size") ? sessionStorage.getItem("size") : null
  );
  const [interestName, setinterestName] = useState(
    sessionStorage.getItem("Interest/AssetType")
      ? sessionStorage.getItem("Interest/AssetType")
      : null
  );

  const [selectedEvent, setselectedEvent] = useState(
    sessionStorage.getItem("Interest/AssetType")
      ? sessionStorage.getItem("Interest/AssetType")
      : null
  );

  const reloadFlase = false;

  // const [expandedRowKeys, setExpandedRowKeys] = useState([]);

  const sortByNameFunction = () => {
    if (sortDirection === "ASC") {
      setSortDirection("DESC");
    } else {
      setSortDirection("ASC");
    }
    sortFunction(sortDirection);
    // setSortBy("name");
    sortByFunction("name");
  };

  const sortByCompanySizeFunction = () => {
    if (sortDirection === "ASC") {
      setSortDirection("DESC");
    } else {
      setSortDirection("ASC");
    }
    sortFunction(sortDirection);
    // setSortBy("size");
    sortByFunction("size");
  };

  const sortByStatusFunction = () => {
    if (sortDirection === "ASC") {
      setSortDirection("DESC");
    } else {
      setSortDirection("ASC");
    }
    sortFunction(sortDirection);
    // setSortBy("approvalStatus");
    sortByFunction("approvalStatus");
  };

  // const reviewPendingCall = () => {
  //   setReviewPending(!reviewPending);
  //   reviewPendingFunction(!reviewPending);
  // };

  const handleCancel = () => {
    setIsModalOpen(false);
  };

  const handleCancelDelete = () => {
    setIsModalDeleteOpen(false);
  };

  // const RemoveHandler = (value) => {
  //   sessionStorage.removeItem(value);
  //   if (value == "interest") {
  //     sessionStorage.removeItem("Interest/AssetType");
  //     setinterestName(null);
  //     setselectedEvent(null);
  //   }
  //   if (value == "sector") {
  //     setSectorId(null);
  //     setSubsectorId(null);
  //     sessionStorage.removeItem("subsector");
  //   }
  //   if (value == "subsector") {
  //     setSubsectorId(null);
  //   }
  //   if (value == "size") {
  //     setSize(null);
  //   }
  // };

  const resendEmailHandler = async (email) => {
    if(!email) {
      toast.error('No email Id found!')
    }
    try {
      const response = await postRequest(
        userServiceApi.resendEmail(),
        {
          email
        }
      )
      if(response) {
        toast.success('Email has been sent successfully')
      }
    }catch(err){
      toast.error(err)
    }
  }

  const deleteApprovedOrg = async (orgId) => {
    // console.log(orgId)
    try {
      const response = await deleteRequest(
        userServiceApi.deleteApprovedOrg(orgId)
      );
      if (response) {
        toast.success("Organisation deleted");
        setIsModalDeleteOpen(false);
        reloadFunction();
      }
    } catch (error) {
      toast.success("Falied to deleted Organisation");
      toast.error(error.error);
    }
  };

  useEffect(() => {
    if (sectorId) {
      setFilterHandler(sectorId, subsectorId, size);
    }
    setTimeout(() => {
      setLoader(false);
    }, 1000);
  }, []);
  useEffect(() => {
    setTableData(data);
  }, [data]);
  const setFilterHandler = async (sectorId, subSectorIds, size) => {
    try {
      const partnerId = sessionStorage.getItem("partnerId")
      const sectorResponse = await getRequest(userServiceApi.getAllSectors(partnerId));
      let selectedSector = sectorResponse.data.find(
        (sector) => sector.id === sectorId
      );
      setSectorName(selectedSector?.name ? selectedSector?.name : "");
      const subSectorResponse = await getRequest(
        userServiceApi.getSubSectors(sectorId)
      );
      let selectedSubSector = subSectorResponse.data.find(
        (sector) => sector.id === subSectorIds
      );
      setSubSectorName(selectedSubSector?.name ? selectedSubSector?.name : "");
      setSectorId(sectorId);
      setSubsectorId(subSectorIds);
      setSize(size);
    } catch { }
  };

  const getAllOrganizationsData = async () => {
    try {
      const response = await getRequest(
        userServiceApi.getAllOrganizations(sortDirection)
      );
      // console.log("tableData", response)
      if (response.data) {
        setTableData(response.data);
        setLoader(false);
      }
    } catch (error) {
      toast.error(error.error);
    }
  };

  const handleDelete = (id) => {
    // console.log("row id", id)
    setIsModalDeleteOpen(true);
    setDeleteRowId(id);
  };

  const deleteOrg = () => {
    deleteApprovedOrg(deleteRowId);
    setIsModalDeleteOpen(false);
    // reloadFunction();
    // window.location.reload();
  };

  const columns = [
    {
      // title: "Organisation details",
      title: (
        <Space>
          Organisation details
          {sortDirection === "ASC" ? (
            <SortDescendingOutlined onClick={sortByNameFunction} />
          ) : (
            <SortAscendingOutlined onClick={sortByNameFunction} />
          )}
        </Space>
      ),
      dataIndex: "mediaLink",
      key: "mediaLink",
      // width: 100,
      className: "organization-details-thead",
      render: (t, r) =>
      (
        <div className="org-details-tcell" onClick={() => navigate('/org-details', { state: { org: r, orgType: "full-member" } })}>
          {r.mediaLink ? (
            <img src={`${r.mediaLink}`} className="image-logo" />
          ) : (
            <img
              src={nologo}
              alt=""
              className="no-logo"
            // style={{ objectFit: "contain", display: "flex", margin: "auto", width: "maxContent" }}
            />
          )
          }
          <Space>
            <span style={{
              fontSize: "17px",
              overflow: "hidden",
              textOverflow: "ellipsis",
              maxWidth: "200px",
              whiteSpace: "nowrap",
              display: "inline-block"
            }}>
              {r.name}
            </span>
          </Space>

        </div>),
    },
    // {
    //   title: (
    //     <Space>
    //       Organisation Name
    //       {sortDirection === "ASC" ? (
    //         <SortDescendingOutlined onClick={sortByNameFunction} />
    //       ) : (
    //         <SortAscendingOutlined onClick={sortByNameFunction} />
    //       )}
    //     </Space>
    //   ),
    //   dataIndex: "name",
    //   key: "name",
    // },
    {
      title: (
        <Space>
          Size
          {sortDirection === "ASC" ? (
            <SortDescendingOutlined onClick={sortByCompanySizeFunction} />
          ) : (
            <SortAscendingOutlined onClick={sortByCompanySizeFunction} />
          )}
        </Space>
      ),
      dataIndex: "size",
      key: "size",
      className: "text-capital",
      render: (record) => (
        <div>
          {record === "MICRO" ? "Micro"
            : record === "SMALL" ? "Small"
              : record === "MEDIUM" ? "Medium"
                : record === "LARGE" ? "Large"
                  : ""
          }
        </div>
      )
    },
    {
      title: (
        <Space>
          Status
          {sortDirection === "ASC" ? (
            <SortDescendingOutlined onClick={sortByStatusFunction} />
          ) : (
            <SortAscendingOutlined onClick={sortByStatusFunction} />
          )}
        </Space>
      ),
      dataIndex: "",
      key: "approvalStatus",
      className: "text-capital",
      render: (record, value) => (
        <div>
          {record.approvalStatus === "APPROVED" ? (
            <p>
              Approved
            </p>
          ) : record.approvalStatus === "DENIED" ? (
            <p>
              Denied
            </p>
          ) : (
            <p>
              Waiting for approval
            </p>
          )}
        </div>
      ),
    },
    {
      title: " ",
      dataIndex: "",
      key: "action",
      // render: (value, row, index) => (
      //   <div style={{ marginLeft: 200 }}>
      //     {row.approvalStatus === "APPROVED" && row.mediaLink !== "" ? (
      //       <Space size="middle">
      //         <div
      //           className="icon-style"
      //           onClick={() => showDetailsHandler(row.id)}
      //         >
      //           <img src={detailsIcon} alt="Details" />
      //           <div className="button-label">Details</div>
      //         </div>
      //         {/* <div
      //           className="icon-style"
      //           onClick={() => showPreviewHandler(row.id)}
      //         >
      //           <img src={previewIcon} alt="Preview" />
      //           <div className="button-label">Preview</div>
      //         </div> */}

      //         {/* <Space>
      //           <div
      //             className="icon-style"
      //             onClick={() => showUnpublishModal(row.id)}
      //           >
      //             <img src={unPublish} alt="Unpublish" />
      //             <div className="button-label">Unpublish</div>
      //           </div>
      //         </Space> */}
      //         {/* <Space>
      //           <Badge
      //             count={row.pendingReviewCount}
      //             showZero
      //             overflowCount={10}
      //             offset={[-10, 0]}
      //           >
      //             <div
      //               className="icon-style"
      //               onClick={() => ReviewHandler(row.id)}
      //             >
      //               <img src={reviewicon} alt="Reviews" />
      //               <div className="button-label">Reviews</div>
      //             </div>
      //           </Badge>
      //         </Space> */}

      //         <div className="icon-style" onClick={() => handleDelete(row.id)}>
      //           <img src={deleteIcon} alt="delete" />
      //           {/* <div className="button-label">Delete</div> */}
      //         </div>
      //       </Space>
      //     ) : row.approvalStatus === "DENIED" ? (
      //       <Space size="middle">
      //         <div
      //           className="icon-style"
      //           onClick={() => showDetailsHandler(row.id)}
      //         >
      //           <img src={detailsIcon} alt="Details" />
      //           <div className="button-label">Details</div>
      //         </div>
      //         <div
      //           className={`icon-style ${isDisabled ? "disabled" : ""}`}

      //         // onClick={() => {
      //         //   // console.log(row.id)
      //         //   setMicrosite(row.id);
      //         //   setIsShowPreview(true)
      //         //   // getMicrositesData(row.id);
      //         // }}
      //         >
      //           <img src={previewIcon} alt="Preview" />
      //           <div className="button-label">Preview</div>
      //         </div>

      //         <Space>
      //           <div className={`icon-style ${isDisabled ? "disabled" : ""}`}>
      //             <img src={unPublish} alt="Unpublish" />
      //             <div className="button-label">Unpublish</div>
      //           </div>
      //         </Space>
      //         <Space>
      //           <div className={`icon-style ${isDisabled ? "disabled" : ""}`}>
      //             <img src={reviewicon} alt="Unpublish" />
      //             <div className="button-label">Reviews</div>
      //           </div>
      //         </Space>
      //         <div className="icon-style" onClick={() => handleDelete(row.id)}>
      //           <img src={deleteIcon} alt="delete" />
      //           <div className="button-label">Delete</div>
      //           {/* <DeleteOutlined className="deleteIcon" style={{marginBottom: "20px"}} onClick={() => handleDelete(row.id)} /> */}
      //           {/* <div className="button-label">Preview</div> */}
      //         </div>
      //       </Space>
      //     ) : (
      //       <Space size="middle">
      //         <div
      //           className="icon-style"
      //           onClick={() => showDetailsHandler(row.id)}
      //         >
      //           <img src={detailsIcon} alt="Details" />
      //           <div className="button-label">Details</div>
      //         </div>
      //         <div
      //           className={`icon-style ${isDisabled ? "disabled" : ""}`}

      //         // onClick={() => {
      //         //   // console.log(row.id)
      //         //   setMicrosite(row.id);
      //         //   setIsShowPreview(true)
      //         //   // getMicrositesData(row.id);
      //         // }}
      //         >
      //           <img src={previewIcon} alt="Preview" />
      //           <div className="button-label">Preview</div>
      //         </div>

      //         <Space>
      //           <div className={`icon-style ${isDisabled ? "disabled" : ""}`}>
      //             <img src={unPublish} alt="Unpublish" />
      //             <div className="button-label">Unpublish</div>
      //           </div>
      //         </Space>
      //         <Space>
      //           <div className={`icon-style ${isDisabled ? "disabled" : ""}`}>
      //             <img src={reviewicon} alt="Unpublish" />
      //             <div className="button-label">Reviews</div>
      //           </div>
      //         </Space>
      //         <div className="icon-style" onClick={() => handleDelete(row.id)}>
      //           <img src={deleteIcon} alt="delete" />
      //           <div className="button-label">Delete</div>
      //           {/* <DeleteOutlined className="deleteIcon" style={{marginBottom: "20px"}} onClick={() => handleDelete(row.id)} /> */}
      //           {/* <div className="button-label">Preview</div> */}
      //         </div>
      //       </Space>
      //     )}
      //   </div>
      // ),
      render: (value, row, index) => (
        <Space size="middle">
          <div
            className="icon-style"
            onClick={() => {
              if (value.mediaLink !== "") {
                navigate("/org-details", { state: { org: row, orgType: "full-member" } });
              }
            }}
          >
            <img
              src={detailsIcon}
              alt="Details"
              style={{ opacity: value.mediaLink !== "" ? 1 : 0.5,     cursor: value.mediaLink !== "" ? 'pointer' : 'no-drop'}}
              title="Preview"
            />
          </div>

          <div className="icon-style" onClick={() => handleDelete(row.id)}>
            <img src={deleteIcon} alt="delete" title="Delete"/>
            {/* <div className="button-label">Delete</div> */}
          </div>
          {!row?.passwordUpdated && <Tooltip title="Re-send email" position="top">
            <div className="icon-style"  onClick={() => resendEmailHandler(row?.email)}>
            <MailOutlined className="resend-email" />
            </div>
          </Tooltip>}
        </Space>
      ),
    }
  ];

  useEffect(() => {
    if (activeKey === "2" && !filterExists) {
      getAllOrganizationsData();
    }
  }, [activeKey, filterExists, sortDirection]);

  const unPublishOrganization = async () => {
    // const headers = {
    //   Authorization: `Bearer ${sessionStorage.getItem("token")}`,
    // };

    try {
      setPublishLoading(true);
      const response = await patchRequest(
        userServiceApi.unPublishMicrosite(rowId)
      );
      if (response) {
        getAllOrganizationsData();

        setPublishLoading(false);

        toast.success(`Site unpublished successfully`);
        setIsModalOpen(false);
      }
      setIsModalOpen(false);
    } catch (error) {
      setPublishLoading(false);
      toast.error(error.message);
      setIsModalOpen(false);
    }
  };

  const handleOk = () => {
    setIsModalOpen(true);
  };

  const closeModalDetails = () => {
    setMicrositeModalDetails(false);
    reloadFunction();
  };

  if (loader) {
    return (
      <div className="data-loader">
        <Spin className="spin" tip="Loading" size="large" />
      </div>
    );
  } else {
    return (
      <div className="table-container">
        <div className="filter-options"></div>
        <Table
          rowClassName={() => "rowClassName1"}
          columns={columns}
          dataSource={tableData}
          showSearchBarHandler={showSearchBarHandler}
          pagination={{
            position: [top, bottom],
          }}
        />
        {/* {reviewPending ? null : ( */}
        <Pagination
          className="pagination"
          defaultCurrent={1}
          pageSize={pageSize}
          total={totalOrgs}
          showTotal={(total) => `Total ${total} Organisations`}
          onChange={(page) => pagNumber(page)}
        />
        {/* )} */}

        {/* Unpublish Modal Popup Start */}
        {/* <Modal
          className="confirmation-modal"
          open={isModalOpen}
          footer={null}
          onOk={handleOk}
          onCancel={handleCancel}
          destroyOnClose={true}
          closable={false}
        >
          <div className="message">
            <p>Are you sure you want to Unpublish?</p>
          </div>
          <div className="modalBtns">
            <Button label="No" className="cancel-btn" onClick={handleCancel}>
              Cancel
            </Button>
            <Button
              label="Yes"
              className="confirm-btn"
              onClick={() => unPublishOrganization()}
            >
              Yes
            </Button>
          </div>
        </Modal> */}
        <Modal
          className="confirmation-modal"
          open={isModalDeleteOpen}
          footer={null}
          onOk={handleOk}
          onCancel={handleCancelDelete}
          destroyOnClose={true}
          closable={false}
        >
          <div className="message">
            <p>Are you sure you want to delete this organisation?</p>
          </div>
          <p className="warning">All the microsites associated with this organisation will be deleted</p>
          <div className="modalBtns">
            <Button
              label="No"
              className="cancel-btn"
              onClick={handleCancelDelete}
            >
              Cancel
            </Button>
            <Button label="Yes" className="confirm-btn" onClick={deleteOrg}>
              Yes
            </Button>
          </div>
        </Modal>

        {/* {micrositeModal ? (
          <ViewMicrosite
            orgId={orgId}
            HideViewMicrositeHandler={HideViewMicrositeHandler}
            showSearchBarHandler={showSearchBarHandler}
            showTagsHandler={showTagsHandler}
            closeModal={closeModal}
          />
        ) : (
          <></>
        )} */}
        {micrositeModalDeatils ? (
          <ViewMicrositeDetails
            orgId={orgId}
            // HideViewMicrositeHandler={HideViewMicrositeHandler}
            showSearchBarHandler={showSearchBarHandler}
            showTagsHandler={showTagsHandler}
            closeModal={closeModalDetails}
          />
        ) : (
          <></>
        )}
        {/* Unpublish Modal Popup End */}
      </div>
    );
  }
};
export default OrganizationTable;
